<template lang="pug">
.ride-card-container
  //- myRideCard
  //- rideMmberBlock
  //- rideCardList
  template(v-if="cardData && cardData.length && cardSceneCheckFinished")
    component(
      v-for="(item, index) in cardData"
      :keyValue="index"
      :is="componentMap[item.moduleCode]"
      :class="item.className"
      :moduleData="item.moduleData"
      :tryingCardData="item.moduleData.tryingCardData"
      :rideMoneyData="rideMoneyData"
      @buyCard="buyCard"
      @buyMember="buyMember"
      @buyUpgrade="buyUpgrade"
      @rideMoneyData="getRideMoneyData"
  )
  buyCardModal(
    :show.sync="showBuyCardModal"
    :buyCardData="buyCardData"
    :agreementInfo="agreementInfo"
  )
  //-  购买单车卡 | 0.01元升级
  buyMemberModal(
    ref="buyMemberModal"
    :show.sync="showBuyMemberModal"
    :buyMemberData="buyMemberData"
    @showRead="showReadFn"
    :isnew="isUpgrade"
    :isUpgrade="isUpgrade"
    :propVersion="propVersion")
  readModal(
    :show="showRead"
    @close="showRead=false"
    @readOk="readOk"
)
  scrollGift(v-if="tabCode === 'bike'")
</template>
<script>
import { getUserDimension } from '@/api/card';
import { getVersion } from '@/utils/systemCode';
import { getTokenAndLocation } from '@/utils';
import myRideCard from './my-ride-card';
import rideCardList from './ride-card-list';
import buyCardModal from './buy-card-modal';
import buyMemberModal from './buy-member-modal';
import readModal from '../read-modal.vue';
// import rideMmberBlockB from './ride-member-blockB.vue';
import rideMmberBlockC from './ride-member-blockC.vue';
import scrollGift from './scroll-gift.vue';
import { ParamsUtil } from '../../../../../utils/params';

export default {
  components: {
    myRideCard,
    rideCardList,
    buyCardModal,
    buyMemberModal,
    readModal,
    // rideMmberBlockB,
    rideMmberBlockC,
    scrollGift,
    // buyCardWord,
  },
  props: {
    rideCardData: {
      type: Array,
      default() {
        return [];
      },
    },
    propVersion: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      env: process.env,
      componentMap: {
        page_my_card_module: 'myRideCard',
        page_sub_tying_card_module: 'rideCardList',
        page_vip_recommend_coupon_visualization_module: 'rideMmberBlockC',
        page_main_tying_card_coupon_visualization_module: 'rideCardList',
        // buy_card_word: 'buyCardWord',
      },
      moduleInfos: [],
      showBuyCardModal: false,
      buyCardData: [],
      showBuyMemberModal: false,
      showRead: false,
      buyMemberData: {},
      cardData: [],
      cardDataS: [],
      rideMoneyData: null,
      tabCode: 'bike',
      isUpgrade: false,
      // 购卡协议模块信息
      agreementInfo: {
        isShowAgreement: false,
      },
      cardSceneCheckFinished: false, // 购卡协议模块信息查询完毕
    };
  },
  provide() {
    return {
      getAgreementInfo: () => this.agreementInfo,
    };
  },
  watch: {
    rideCardData: {
      deep: true,
      immediate: true,
      handler(val) {
        this.cardData = val;
      },
    },
  },
  created() {
    const {
      tabCode,
    } = ParamsUtil.getParams(window.location.href);
    this.tabCode = tabCode || 'bike';
  },
  mounted() {
    this.cardData = this.rideCardData;
    this.init();
  },
  methods: {
    init() {
      const pageSubTyingCardModule = this.cardData.find((module) => module.moduleCode === 'page_sub_tying_card_module');
      if (pageSubTyingCardModule) {
        const moduleData = pageSubTyingCardModule.moduleData || {};
        this.cardSceneCheck({ channelCode: moduleData.channelCode });
      } else {
        this.cardSceneCheckFinished = true;
      }
    },
    showReadFn() {
      this.showRead = true;
    },
    buyMember(val, isUpgrade = false) {
      this.buyMemberData = val;
      this.showBuyMemberModal = true;
      this.isUpgrade = isUpgrade;
    },
    buyUpgrade(val) {
      this.buyMember(val, true);
    },
    buyCard(val) {
      if (Array.isArray(val)) {
        this.buyCardData = val;
      } else {
        this.buyCardData = [val];
      }
      this.showBuyCardModal = true;
      // getNoScroll(true);
    },
    readOk() {
      this.$refs.buyMemberModal.readOk();
    },
    getRideMoneyData(val) {
      this.rideMoneyData = val;
    },
    /**
     * 用户维度业务场景校验（判断是否需要展示购卡协议）
     */
    async cardSceneCheck(option) {
      try {
        let { channelCode } = option;
        const { token, adCode, cityCode } = await getTokenAndLocation();
        if (typeof channelCode === 'string') {
          channelCode = Number(channelCode);
        }
        const queryParams = ParamsUtil.getParams(window.location.href);
        const tabCode = queryParams.tabCode || 'bike';
        const businessTypeMap = {
          bike: 1, // 单车
          ebike: 2, // 助力车
        };
        const result = await getUserDimension({
          token,
          adCode,
          cityCode,
          sceneType: 'purchaseAgreement',
          businessType: businessTypeMap[tabCode],
          channelCode,
          version: await getVersion(),
        });
        this.agreementInfo = this.agreementInfoAdapter(result.data);
        this.cardSceneCheckFinished = true;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
        this.cardSceneCheckFinished = true;
      }
    },
    /**
     * 合规命中接口数据处理
     * @param data 合规命中返回的数据
     * @typedef {Object} AgreementInfo
     * @property {boolean} isShowAgreement - 是否展示购卡协议
     * @property {string} agreementUrl - 购卡协议链接
     * @property {string} agreementTitle - 协议标题
     * @returns { AgreementInfo } 格式化数据
     */
    agreementInfoAdapter(data) {
      let agreementInfo = {
        isShowAgreement: false,
        agreementUrl: '',
        agreementTitle: '',
      };
      if (data.agreementInfo) {
        agreementInfo = {
          ...data.agreementInfo,
          isShowAgreement: data.agreementInfo.gray,
          agreementUrl: data.agreementInfo.clickUrl,
          agreementTitle: data.agreementInfo.title,
        };
      }
      return agreementInfo;
    },
  },
};
</script>
<style lang="less" scoped>
.ride-card-container {
  padding-bottom: 0.93rem;
  margin-top: 0.09rem;

  &::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
    color: transparent;
  }
}
</style>
